import { Choice } from '90.quickConnect.Models/models';

export default function findChoiceInChoiceList(choices: Choice[], choicesToFind: Choice[]): Choice[] {
  const normalize = (value?: string) => value?.toLocaleLowerCase() ?? '';

  const choicesMap = new Map<string, Choice>();

  choices.forEach((choice) => {
    choicesMap.set(normalize(choice.value), choice);
    choicesMap.set(normalize(choice.label), choice);
  });

  return choicesToFind.flatMap((choiceToFind) => {
    const foundChoice = choicesMap.get(normalize(choiceToFind.value)) ?? choicesMap.get(normalize(choiceToFind.label));

    return foundChoice ? [foundChoice] : [];
  });
}
